import React from 'react';
import { SiteData } from '../types/data';

interface PricingProps {
  data: SiteData['pricing'];
}

export const Pricing = ({ data }: PricingProps) => {
  return (
    <section id="cenik" className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">{data.title}</h2>
          <p className="text-lg text-gray-600">
            {data.description}
          </p>
        </div>

        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="px-6 py-4 text-gray-900 font-bold text-lg">Služba</th>
                  <th className="px-6 py-4 text-gray-900 font-bold text-lg text-right">Cena</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {data.items.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 text-gray-700 font-medium">{item.service}</td>
                    <td className="px-6 py-4 text-primary font-bold text-right whitespace-nowrap">{item.price}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
            <p className="text-sm text-gray-500 italic text-center">
              {data.note}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
